import ChangeSalesRepModal from './ChangeSalesRepModal.container'

export default ChangeSalesRepModal
